import { global, getRelativeSiteURL, getSiteAbsoluteURL, isEmpty, isUnDefined } from "../Common/saop-common";
import { SaopViewForm } from "../Core/saop-view-form";
import { SaopUploadFiles } from "../Components/saop-upload-files";
import { SaopAttachmentList } from "../Components/saop-attachment-list";
import { OPNPotniNalogiGoggleMapsView } from "../OPN/OPNPotniNalogiGoggleMaps-view";
import { SaopMessageDlg, SaopMsgDlgButton } from '../Components/saop-message-dlg';
import { SaopServicesCore } from "../Core/saop-services-core";
import { SaopFloatingLabel } from '../Components/saop-floating-label';


export class LIKVCakalnaVrstaCommentConfirm extends SaopViewForm {
  private _formId:string;
  private _saopFloatingLabel:SaopFloatingLabel = new SaopFloatingLabel();


  constructor(viewId:string,libName:string = ""){
    super(viewId,libName);
    this.setDictionary();  
    this.title = this.translationService.translate("Potrdi dokument");
    this.fullTitle = this.title;
    this.addRecordEndpoint = "";
    this.editRecordEndpoint = "LikvConfirmations/AddCommentConfirm";
    this.deleteRecordEndpoint = ""; 
    //
    this.afterViewShowSuccess = this.initView;
    this.afterSubmitSuccess = this.initView;
    //
  }

  setDictionary(){
      let dictionary:string[] = ["Potrjevanje: prejeti račun","Razlog zavrnitve je obvezen podatek.","Potrdi dokument"];
      this.setTerminologyList(dictionary);
  } 


  public initView():void{
    this.LoadViewEvents();
  }

  public LoadViewEvents ():void{
    let _viewDiv = $(this.id);
    if (_viewDiv.length == 0) {return;}

    let _this = this;
    this._formId = "#mainLikvCakalnaVrstaCommentConfirm";

    $("#AddCommentConfirmView").find("#btnConfirm").off("click");
    $("#AddCommentConfirmView").find("#btnConfirm").on('click', function(row){
      _this.onConfirmClick();
    });       
  }

  public onConfirmClick (): void{
    global.ConsoleLogDegug("LIKVCakalnaVrstaCommentConfirm.onConfirmClick");    
    let _komentar =  $("#AddCommentConfirmView").find("#Komentar")[0] as HTMLInputElement;
    let _komentarText =  _komentar.value;
    global.ConsoleLogDegug("LIKVCakalnaVrstaComment.onConfirmClick.submit");    
    this.CloseViewForm();
    $("#LikvConfirmationsEditView").find("#desktopKomentar").val(_komentarText);
    $("#LikvConfirmationsEditView").find("#mobileKomentar").val(_komentarText);            
    $("#LikvConfirmationsEditView").find("#Status").val(0);
    $("#LikvConfirmationsEditView").submit(); 
  }
  //
}

